import { SuraBrokerageHouseId, INVESTMENT_OFFICES } from 'constants/globals';

export const DEFAULT_ENTITY_DOMAIN = 'clients';

export type EntityDomainRule = {
  investmentOfficeId: string;
  brokerageHouseId: string;
  entityDomain: string;
};

/** Extiende esta tabla para nuevas combinaciones oficina + institución → entityDomain. */
export const ENTITY_DOMAIN_RULES: ReadonlyArray<EntityDomainRule> = [
  {
    investmentOfficeId: INVESTMENT_OFFICES.SURA,
    brokerageHouseId: SuraBrokerageHouseId.ALLIANZ,
    entityDomain: 'consolidated',
  },
];

export function resolveEntityDomain(
  investmentOfficeId: string,
  brokerageHouseId: string,
): string {
  const rule = ENTITY_DOMAIN_RULES.find(
    (r) =>
      r.investmentOfficeId === investmentOfficeId &&
      r.brokerageHouseId === String(brokerageHouseId),
  );
  return rule?.entityDomain ?? DEFAULT_ENTITY_DOMAIN;
}
